/**
 * 游戏相关适配器
 * ✅ 完全支持 - API已实现
 */

import type { GameSummary, GameDetailResponse, ListGamesParams } from '../api/types';
import type { AdapterResult } from './types';
import { FeatureStatus } from './types';
import { apiClient } from './index';

export const gameAdapter = {
  /**
   * 获取游戏列表
   * ✅ 完全支持
   */
  async listGames(params?: ListGamesParams): Promise<AdapterResult<{ games: GameSummary[]; hasMore: boolean }>> {
    try {
      const response = await apiClient.listGames(params);
      
      return {
        data: {
          games: response.games,
          hasMore: response.meta?.hasMore ?? false,
        },
        status: FeatureStatus.AVAILABLE,
      };
    } catch (error) {
      throw error;
    }
  },

  /**
   * 获取游戏详情
   * ✅ 完全支持
   */
  async getGameDetail(idOrSlug: string): Promise<AdapterResult<GameDetailResponse>> {
    try {
      const response = await apiClient.getGame(idOrSlug);
      
      return {
        data: response, // response 就是 GameDetailResponse
        status: FeatureStatus.AVAILABLE,
      };
    } catch (error) {
      throw error;
    }
  },

  /**
   * 记录游戏浏览
   * ✅ 完全支持
   */
  async trackView(gameId: string): Promise<void> {
    try {
      await apiClient.trackView(gameId);
    } catch (error) {
      // 统计失败不影响主流程
      console.warn('Track view failed:', error);
    }
  },

  /**
   * 记录游戏点击
   * ✅ 完全支持
   */
  async trackClick(gameId: string, platformId: string): Promise<void> {
    try {
      await apiClient.trackClick(gameId, platformId);
    } catch (error) {
      // 统计失败不影响主流程
      console.warn('Track click failed:', error);
    }
  },
};
